/**
 * Generated runtime TestId mirror for frontend/src/pages/provisioning/ProvisioningTaskDetail.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

export const ProvisioningTaskDetailTestIds = {
  btnRetryTask: "btn-retry-task",
  errorCard: "error-card",
  errorLogLink: "error-log-link",
  errorMessage: "error-message",
  linkIdentity: "link-identity",
  linkTargetSystem: "link-target-system",
  nextRetryAt: "next-retry-at",
  statusBadge: "status-badge",
  taskDetailTitle: "task-detail-title",
  taskInfoCard: "task-info-card",
  timelineCard: "timeline-card",
  timelineEntries: "timeline-entries"
} as const;
